import Input from '@material-ui/core/Input';
import Select from '@material-ui/core/Select';
import KeyboardArrowDownIcon from '@material-ui/icons/ArrowDropDown';
import { Option } from '../utils';
import { useTranslation } from 'react-i18next';

interface Props<T> {
  id?: string;
  inputProps?: string;
  name?: string;
  onChange: (value: T) => void;
  options: Option<T>[];
  localizedOptions?: string[];
  value?: T;
  isOptional?: boolean;
  placeholder?: string;
  style?: Record<string, string>;
}

export function SelectInput<T>(props: Props<T>) {
  const {
    id,
    name,
    onChange,
    options,
    value,
    isOptional,
    placeholder = 'Select an option',
    style,
    localizedOptions,
  } = props;
  const { t } = useTranslation();
  const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    const { value } = event.currentTarget;
    try {
      const parsed = JSON.parse(value as string);
      onChange(parsed);
    } catch (err) {
      console.log(`SelectInput: error parsing value ${value}`, err);
    }
  };

  return (
    <Select
      id={id}
      IconComponent={KeyboardArrowDownIcon}
      input={<Input disableUnderline />}
      inputProps={{
        style: {
          backgroundColor: 'white',
          borderColor: 'var(--color-border-gray)',
          borderStyle: 'solid',
          borderWidth: '1px',
          padding: '12px 20px',
          ...style,
        },
      }}
      fullWidth
      name={name}
      native
      onChange={handleChange}
      value={JSON.stringify(value)}
      variant="outlined"
    >
      {!value && (
        <option value="">
          {t(placeholder)}
          {isOptional && ` (${t('Optional')})`}
        </option>
      )}
      {options.map(({ key, value, display }, i) => (
        <option key={key} value={JSON.stringify(value)}>
          {localizedOptions ? localizedOptions[i] : t(display)}
        </option>
      ))}
    </Select>
  );
}
